export const TEMPORARY_INVITATION_TEAM_NAME = 'Digital Realty DC10';

export const INVITATION_ACCEPTANCE_ERROR_MESSAGE =
  'We could not accept this invitation. The link may be invalid or expired.';

export const INVITATION_REVOKED_MESSAGE =
  'This invitation has been revoked. Request a new invitation from your team administrator.';
